module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigate-by-keyword-container"
  }, [_c('div', {
    staticClass: "add-keyword-list-mapping-button-container"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-rounded btn-ageinput add-keyword-list-mapping-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addMapping
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._l((_vm.keywordMappingList), function(item, index) {
    return _c('div', {
      key: item.mappingUniqueId,
      staticClass: "navigate-by-keyword-mapping-container"
    }, [_c('div', [_c('span', [_c('strong', [_vm._v(_vm._s(item.mappingUniqueId || "keyword_set_1"))])])]), _vm._v(" "), _c('div', {
      staticClass: "navigate-by-keyword-conversation-dropdown"
    }, [_c('treeselect', {
      staticClass: "treeselect-box",
      attrs: {
        "placeholder": "Select conversation",
        "options": _vm.conversationOptions
      },
      on: {
        "input": function (val) { return _vm.getKeywords(val, index); }
      },
      model: {
        value: (_vm.selectedConversation[index]),
        callback: function($$v) {
          _vm.$set(_vm.selectedConversation, index, $$v)
        },
        expression: "selectedConversation[index]"
      }
    }), _vm._v(" "), (_vm.conversationInvalid[index]) ? _c('div', {
      staticClass: "error-message"
    }, [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v("Conversation is required.")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "navigate-by-keyword-conversation-dropdown"
    }, [_c('treeselect', {
      staticClass: "treeselect-box",
      attrs: {
        "placeholder": "Select keyword",
        "options": _vm.keywordOptions[index],
        "limit": 2,
        "multiple": true
      },
      on: {
        "input": function (val) { return _vm.selectKeywords(val, index); }
      },
      model: {
        value: (_vm.keywordsSelected[index]),
        callback: function($$v) {
          _vm.$set(_vm.keywordsSelected, index, $$v)
        },
        expression: "keywordsSelected[index]"
      }
    }), _vm._v(" "), (_vm.keywordsInvalid[index]) ? _c('div', {
      staticClass: "error-message"
    }, [_c('span', {
      staticClass: "text-danger"
    }, [_vm._v("At least one keyword is required.")])]) : _vm._e()], 1), _vm._v(" "), _c('button', {
      staticClass: "btn btn-rounded btn-remove-nudge btn-nudge btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeMapping(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('strong', [_vm._v("Add Mapping")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0e57509e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/processing-functions/pf-navigate-by-keyword.vue
// module id = frXL
// module chunks = 1